import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ResetPasswordState {
  email: string | null;
}

const initialState: ResetPasswordState = { email: null };

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    setResetEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    clearResetEmail: (state) => {
      state.email = null;
    },
  },
});

export const { setResetEmail, clearResetEmail } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
